// extracted by mini-css-extract-plugin
export default {"tabletImg":"hL","desktopImg":"iL","mobileImg":"jL","backgroundImage":"kL","content":"lL","rtbLeft":"mL","rtbRight":"nL","imageContainer":"oL","rtbBox":"pL","line":"qL"};
    if(module.hot) {
      // 1713809678564
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  